const cards = [
  {
    id: 1,
    title: '顶流男星疑似恋情曝光，深夜同回小区引发热议',
    summary: '有媒体拍到某顶流男星与神秘女子深夜同回住所，画面清晰度极高，粉丝群体反应激烈……',
    tag: '娱乐圈',
    time: '2小时前',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20city%20night%20scene%20with%20apartment%20building%20silhouette%20and%20warm%20street%20lights%2C%20mysterious%20romantic%20atmosphere%2C%20coral%20and%20amber%20color%20palette%2C%20modern%20editorial%20style%2C%20no%20text%20no%20letters%2C%20soft%20glow%20effects&width=800&height=560&seq=card-01-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '某热播综艺节目录制现场爆发冲突，导演组紧急叫停',
    summary: '据现场观众爆料，两位嘉宾在录制过程中因观点不合发生激烈争执，节目组已介入调解……',
    tag: '综艺圈',
    time: '4小时前',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20TV%20studio%20set%20with%20dramatic%20lighting%20and%20two%20facing%20silhouettes%2C%20tense%20atmosphere%2C%20coral%20and%20amber%20tones%2C%20modern%20editorial%20design%2C%20no%20text%20no%20letters%2C%20conflict%20theme&width=800&height=560&seq=card-02-2026&orientation=landscape',
  },
  {
    id: 3,
    title: '千万粉丝网红被曝虚假宣传，品牌方连夜发声明',
    summary: '某知名带货主播所售产品被消费者投诉与宣传严重不符，涉事品牌紧急发布致歉声明……',
    tag: '网红圈',
    time: '6小时前',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20live%20streaming%20shopping%20scene%20with%20product%20display%20and%20warning%20symbols%2C%20consumer%20protection%20theme%2C%20coral%20amber%20warm%20palette%2C%20modern%20editorial%20style%2C%20no%20text%20no%20letters&width=800&height=560&seq=card-03-2026&orientation=landscape',
  },
  {
    id: 4,
    title: '电竞战队官宣重大人员变动，老将离队引发猜测',
    summary: '知名电竞俱乐部突然宣布核心选手转会，粉丝社区炸开了锅，各种猜测层出不穷……',
    tag: '电竞圈',
    time: '8小时前',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20esports%20competition%20stage%20with%20empty%20gaming%20chair%20under%20spotlight%2C%20departure%20and%20change%20theme%2C%20coral%20amber%20warm%20colors%2C%20modern%20editorial%20design%2C%20no%20text%20no%20letters&width=800&height=560&seq=card-04-2026&orientation=landscape',
  },
  {
    id: 5,
    title: '暑期档电影票房黑马诞生，小成本制作逆袭夺冠',
    summary: '一部没有大牌明星的小成本影片凭借口碑发酵，上映首周即登顶票房榜首引发行业震动……',
    tag: '影视圈',
    time: '10小时前',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20cinema%20entrance%20with%20long%20queue%20and%20movie%20poster%20glow%2C%20box%20office%20success%20theme%2C%20coral%20amber%20warm%20palette%2C%20modern%20editorial%20style%2C%20no%20text%20no%20letters%2C%20exciting%20atmosphere&width=800&height=560&seq=card-05-2026&orientation=landscape',
  },
  {
    id: 6,
    title: '某品牌代言人翻车，大量粉丝要求解约更换代言',
    summary: '品牌最新代言人因个人争议事件引发舆论危机，社交平台涌现大量解约呼声……',
    tag: '商业圈',
    time: '12小时前',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20brand%20billboard%20covered%20with%20question%20marks%20and%20social%20media%20bubbles%2C%20brand%20crisis%20theme%2C%20coral%20amber%20warm%20colors%2C%20modern%20editorial%20design%2C%20no%20text%20no%20letters&width=800&height=560&seq=card-06-2026&orientation=landscape',
  },
  {
    id: 7,
    title: '音乐节主办方回应票务争议：将全额退款并补偿',
    summary: '上周末举行的户外音乐节因场地问题导致大规模观众不满，主办方最新回应来了……',
    tag: '音乐圈',
    time: '14小时前',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20outdoor%20music%20festival%20crowd%20with%20stage%20lights%20and%20colorful%20atmosphere%2C%20event%20theme%2C%20coral%20amber%20warm%20palette%2C%20modern%20editorial%20design%2C%20no%20text%20no%20letters%2C%20festival%20vibe&width=800&height=560&seq=card-07-2026&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            🍉 热门大瓜
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            精选今日最值得关注的吃瓜事件，每日必吃大瓜汇总
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card) => (
            <a
              key={card.id}
              href="#cards"
              className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-[10px] font-label font-medium whitespace-nowrap">
                    {card.tag}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{card.time}</span>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug mb-1.5">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-400 leading-relaxed line-clamp-2">
                  {card.summary}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}